export const AFRAME: any = (window as any).AFRAME || {}